import axios from "./axios";

const buildUrl = function(module, url) {
  const config = window.config;
  switch (module) {
    case "basic":
      return config.basicServerUrl + url;
    case "maint":
      return config.maintServerUrl + url;
    case "autoPrint":
      return config.autoPrintServerUrl + url;
    case "repair":
      return config.repairServerUrl + url;
    default:
      throw "未知模块名称：" + module;
  }
};

const httpInst = {
  /**
   * Get方法获取数据
   * get(String url,Object params) 示例get('users',{pageNum:1})
   */
  get: (module, url, params, headers, timeout) => {
    return axios({
      url: buildUrl(module, url),
      method: "get",
      params: params,
      headers: headers,
      timeout: timeout,
    });
  },

  exportFile: function(module, url, params, timeout) {
    return axios({
      timeout: timeout,
      url: buildUrl(module, url),
      method: "get",
      params: params,
      responseType: "blob",
    });
  },

  postForFile: (module, url, data, params, timeout) => {
    return axios({
      timeout: timeout,
      url: buildUrl(module, url),
      method: "post",
      data: data,
      params: params,
      responseType: "blob",
    });
  },
  getForFile: (module, url, data, params, timeout) => {
    return axios({
      timeout: timeout,
      url: buildUrl(module, url),
      method: "get",
      data: data,
      params: params,
      responseType: "blob",
    });
  },

  put: (module, url, data, params) => {
    return axios({
      url: buildUrl(module, url),
      method: "put",
      data: data,
      params: params,
    });
  },

  post: (module, url, data, params) => {
    return axios({
      url: buildUrl(module, url),
      method: "post",
      data: data,
      params: params,
    });
  },

  postJson: (module, url, data, headers) => {
    return axios({
      url: buildUrl(module, url),
      method: "post",
      data: data,
      headers: {
        ...headers,
        "Content-Type": "application/json",
      },
    });
  },

  // 删除,示例delete('users',10)
  delete: (module, url, id) => {
    return axios({
      url: buildUrl(module, url) + "/" + id,
      method: "delete",
    });
  },

  save: (module, url, data) => {
    return axios({
      url: buildUrl(module, url),
      method: (!data.id || data.id === 0) && (!data.pkid || data.pkid === 0) && (!data.pkId || data.pkId === 0) ? "post" : "put",
      data: data,
    });
  },

  saveByPKID: (module, url, data) => {
    return axios({
      url: buildUrl(module, url),
      method: !data.pkid || data.pkid === 0 ? "post" : "put",
      data: data,
    });
  },
  request: (module, config) => {
    config.url = buildUrl(module, config.url);
    return axios(config);
  },

  // 触发浏览器下载二进制文件
  triggerDownload: (data, defaultFileName) => {
    let fileName = defaultFileName || "导出数据.xlsx";
    // 尝试从响应头里取后端写入的真实文件名（content-disposition）
    const disposition = (data && data.headers && (data.headers["content-disposition"] || data.headers["Content-Disposition"])) || "";
    const match = /filename\*=utf-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition);
    if (match) {
      try { fileName = decodeURIComponent(match[1] || match[2]); } catch (e) { /* keep default */ }
    }
    const buffer = data && data.data;
    const blob = new Blob([buffer], { type: "application/vnd.ms-excel" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  },

  // 导出表格数据（GET）：params 走 query string
  exportExcel: (module, url, params, exportColumns, method = "get", fileName) => {
    const headers = { "Export-Excel": 1 };
    if (exportColumns !== undefined && exportColumns !== null && exportColumns !== "") {
      headers["Export-Excel-Include-Columns"] = exportColumns;
    }
    return axios({
      url: buildUrl(module, url),
      method,
      params: params,
      responseType: "arraybuffer",
      headers,
    }).then((res) => {
      httpInst.triggerDownload(res, fileName);
      return res;
    });
  },

  // 导出表格数据（POST）：data 走 request body
  exportExcelPost: (module, url, data, exportColumns, method = "post", fileName) => {
    const headers = { "Export-Excel": 1 };
    if (exportColumns !== undefined && exportColumns !== null && exportColumns !== "") {
      headers["Export-Excel-Include-Columns"] = exportColumns;
    }
    return axios({
      url: buildUrl(module, url),
      method,
      data: data,
      responseType: "arraybuffer",
      headers,
    }).then((res) => {
      httpInst.triggerDownload(res, fileName);
      return res;
    });
  },
};

export default httpInst;
